// language=GraphQL
export const ALL_MAP_MARKERS_QUERY = `query Query {
  mapMarkers: itineraryMapMarkers {
    id
    lat
    lng
  }
}`

// language=GraphQL
export const SINGLE_MAP_MARKER_QUERY = `query Query($id: ID!) {
  mapMarker: itineraryMapMarker(id: $id) {
    id
    lat
    lng
  }
}`

// language=GraphQL
export const CREATE_MAP_MARKER_MUTATION = `
  mutation Mutation($input: CreateItineraryMapMarkerInput) {
    mapMarker: createItineraryMapMarker(input: $input) {
      id
      lat
      lng
    }
  }`

// language=GraphQL
export const UPDATE_MAP_MARKER_MUTATION = `
  mutation Mutation($input: UpdateItineraryMapMarkerInput) {
    mapMarker: updateItineraryMapMarker(input: $input) {
      id
      lat
      lng
    }
  }`

// language=GraphQL
export const DELETE_MAP_MARKER_MUTATION = `
  mutation Mutation($input: DeleteItineraryMapMarkerInput) {
    deleteItineraryMapMarker(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_MAP_MARKER_MUTATION = `
  mutation Mutation($input: DeleteItineraryMapMarkerInput) {
    forceDeleteItineraryMapMarker(input: $input) {
      success
    }
  }`
// language=GraphQL
export const MAP_MARKERS_DEPENDENTS_QUERY = `query Query($id: ID!, $withItineraryItems: Boolean = false) {
  groupedDependents: itineraryMapMarkerDependents(id: $id) {
    itineraryItems @include(if: $withItineraryItems) {
      id
      duration
      title
      text
    }
  }
}`
